<template>
  <section class="content" v-if="rules">
    <h2 class="subtitle">
      Rules for Submission
    </h2>
    <ul id="rules">
      <li v-for="(rule, index) in rules" :key="index" v-html="rule"></li>
    </ul>
  </section>
</template>

<script>
export default {
  computed: {
    welcome() {
      return this.$store.state.welcome;
    },
    rules() {
      return this.$store.state.rules;
    },
  },
};
</script>
